import http from 'axios'

export default {
  createDemandeInformationAbonnement: (numtiers, fonctionnalite) => {
    return http.post(`/web/v1/${numtiers}/abonnement/demande-infos?fonctionnalite=${fonctionnalite}`)
  },
  getHasDemandeRecente: (numtiers) => {
    return http.get(`/web/v1/${numtiers}/abonnement/demande-infos/recent`)
  },
}
